import { FlexBox } from '@dixa/lib-shared-habla';
import classnames from 'classnames';

import { Title } from '../Title';

import styles from './ArticleContent.module.scss';

import { CategoryTags } from './index';

type ArticleContentProps = {
  articleTitle: string;
  articleTags: string[];
  categoryTitle: string;
  className: string;
};
export function ArticleContent({
  articleTitle,
  articleTags,
  categoryTitle,
  className,
}: ArticleContentProps): JSX.Element {
  return (
    <FlexBox
      flexDirection="column"
      className={classnames(styles.wrapper, className)}
    >
      <Title title={articleTitle} />
      <CategoryTags categoryTitle={categoryTitle} articleTags={articleTags} />
    </FlexBox>
  );
}
